import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { supportedLanguages, type SupportedLanguage } from '@/i18n';

export function useLanguage() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = (supportedLanguages.includes(lang as SupportedLanguage) ? lang : 'en') as SupportedLanguage;

  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang, i18n]);

  const switchLanguage = (newLang: SupportedLanguage) => {
    const pathWithoutLang = location.pathname.replace(/^\/(en|et)/, '');
    const search = location.search;
    const hash = location.hash;
    navigate(`/${newLang}${pathWithoutLang || '/'}${search}${hash}`, { replace: true });
  };

  // Helper to create language-prefixed paths
  const localePath = (path: string) => {
    if (path.startsWith('/#')) {
      return `/${currentLang}/#${path.substring(2)}`;
    }
    return `/${currentLang}${path.startsWith('/') ? path : `/${path}`}`;
  };

  return { currentLang, switchLanguage, localePath };
}
